import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent } from '@nuxtjs/composition-api';
import { SIcon, STextButton } from '@strana-artw/ui-kit';
export default defineComponent({
  name: 'CIconButton',
  components: {
    STextButton: STextButton,
    SIcon: SIcon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hideTextOnMobile: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: undefined
    },
    iconSize: {
      type: Number,
      default: 24
    },
    iconPosition: {
      type: String,
      default: 'left',
      validator: function validator(iconPosition) {
        return ['left', 'right'].includes(iconPosition);
      }
    },
    text: {
      type: String,
      default: undefined
    }
  },
  computed: {
    slotName: function slotName() {
      if (this.iconPosition === 'left') {
        return 'before';
      }
      return 'after';
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  }
});